import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { getModule } from '@jwp/ott-common/src/modules/container';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';
import env from '@jwp/ott-common/src/env';

import { modalURLFromLocation } from '../../utils/location';
import Button from '../Button/Button';
import DialogBackButton from '../DialogBackButton/DialogBackButton';

import styles from './LoginExternalForm.module.scss';

type Props = {
  providers: { name: string; url?: string; oauth?: string; icon?: string; translationKey: string }[];
};

const LoginExternalForm: React.FC<Props> = ({ providers }: Props) => {
  const { t } = useTranslation('account');
  const location = useLocation();
  const navigate = useNavigate();
  const accountController = getModule(AccountController);

  // t('login.login_with_mijn_bibliotheek')
  // t('login.login_with_kb')

  return (
    <>
      <div className={styles.providers}>
        {providers.map(({ name, url, oauth, icon, translationKey }) => (
          <Button
            className={styles.button}
            startIcon={icon ? <img width={24} height={24} src={icon} alt={name} /> : undefined}
            label={t(`login.login_with_${translationKey}`)}
            variant="contained"
            key={name}
            size="large"
            onClick={oauth ? () => accountController.loginExternal(oauth, env.APP_PUBLIC_URL) : undefined}
            to={!oauth ? url : undefined}
            fullWidth
          />
        ))}
      </div>
      <DialogBackButton onClick={() => navigate(modalURLFromLocation(location, 'login'))} />
    </>
  );
};

export default LoginExternalForm;
